import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AdminAddGeneralComponent } from "../admin-add-general/admin-add-general.component";
import { AdminUsersAdminViewComponent } from "../admin-users-admin-view/admin-users-admin-view.component";
import { AdminUsersDriversViewComponent } from "../admin-users-drivers-view/admin-users-drivers-view.component";
import { AdminUsersTruckownerViewComponent } from "../admin-users-truckowner-view/admin-users-truckowner-view.component";
import { AdminUserscustomerViewComponent } from "../admin-userscustomer-view/admin-userscustomer-view.component";
import { AdminUserAdminResetPasswordComponent } from "../admin-user-admin-reset-password/admin-user-admin-reset-password.component";
import { AdminUsersCreateEmployeeLoginComponent } from "../admin-users-create-employee-login/admin-users-create-employee-login.component";
import { AdminUsersEmployeesViewComponent } from "../admin-users-employees-view/admin-users-employees-view.component";
import { AdminService } from "../admin.service";
import { customerList } from "./customerList";
import { driverList } from "./driverList";
import { adminList } from "./adminList";
import { truckOwnerList } from "./truckownerList";
import { employeeList } from "./employeeList";
import { AdminUsersAdminAddComponent } from "../admin-users-admin-add/admin-users-admin-add.component";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AdminEditDriversComponent } from "../admin-edit-drivers/admin-edit-drivers.component";

@Component({
  selector: "app-admin-users",
  templateUrl: "./admin-users.component.html",
  styleUrls: ["./admin-users.component.css"],
})
export class AdminUsersComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    "uid",
    "name",
    "mobile",
    "Login",
    "Trips",
    "CustomerType",
    "Status",
  ];
  displayedTruckColumns: string[] = [
    "ID",
    "name",
    "mobile",
    "Login",
    "Trips",
    "Status",
  ];
  displayedDriverColumns: string[] = [
    "ID",
    "name",
    "mobile",
    "Login",
    "Trips",
    "Status",
  ];
  dispalyedAdminColumns: string[] = [
    "eID",
    "name",
    "username",
    "mobile",
    "role",
    "sms",
    "resetpassword",
    "status",
  ];
  dispalyedEmployeeColumns: string[] = [
    "eid",
    "username",
    "mobile",
    "email",
    "resetpassword",
  ];
  fetch_page: any = 1;
  truck_fetch_page: any = 1;
  driver_fetch_page: any = 1;
  dr_fetch_page: any = 1;
  employee_fetch_page: any = 1;
  admin_fetch_page: any = 1;
  currentPage: any = 1;
  startPage: any = 1;
  truckStartPage: any = 1;
  driverStartPage: any = 1;
  adminStartPage: any = 1;
  employeeStartPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  perPage: any = 10;
  customerMobile = -1;
  truckownerMobile = -1;
  driverMobile: any = -1;
  selectedUserType: any = "Customers";
  matDialogref!: MatDialogRef<AdminUserscustomerViewComponent>;
  MatDialogref!: MatDialogRef<AdminUsersTruckownerViewComponent>;
  Matdialogre!: MatDialogRef<AdminUsersAdminViewComponent>;
  Matdialogr!: MatDialogRef<AdminUsersEmployeesViewComponent>;
  // Matdialogref!: MatDialogRef<AdminUsersDriversViewComponent>; // older dialog box 
  Matdialogref!: MatDialogRef<AdminEditDriversComponent>;
  matdialogref!: MatDialogRef<AdminAddGeneralComponent>;
  matdialogrefe!: MatDialogRef<AdminUserAdminResetPasswordComponent>;
  Matdialogrefe!: MatDialogRef<AdminUsersCreateEmployeeLoginComponent>;
  Matdialogrefee!: MatDialogRef<AdminUsersAdminAddComponent>;
  token: any;
  selectedType: string;
  userCustomer: boolean = true;
  userTruckOwner: boolean = false;
  userDriver: boolean = false;
  userAdmin: boolean = false;
  userEmployees: boolean = false;
  customerUserList: MatTableDataSource<customerList>;
  truckOwnerUserList: MatTableDataSource<truckOwnerList>;
  driverUserList: MatTableDataSource<driverList>;
  adminUserList: MatTableDataSource<adminList>;
  employeeUserList: MatTableDataSource<employeeList>;
  @ViewChild(MatSort) sort: MatSort = Object.create(null);
  @ViewChild(MatSort) truckOwnersort: MatSort = Object.create(null);
  @ViewChild(MatSort) driversort: MatSort = Object.create(null);
  @ViewChild(MatSort) adminrsort: MatSort = Object.create(null);
  @ViewChild(MatPaginator) paginatorCustomer: MatPaginator =
    Object.create(null);
  @ViewChild(MatPaginator) paginatorTruckOwner: MatPaginator =
    Object.create(null);
  @ViewChild(MatPaginator) paginatorDrivers: MatPaginator = Object.create(null);
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;
  @ViewChild("newItem") newItem!: ElementRef;

  searchButton: boolean = true;
  toggleSearch: boolean = false;
  searchAdminName: any = -1;
  searchEmployeeName: any = -1;
  employeeCreate: boolean = true;
  customerdata: any;
  customerloading: boolean = false;
  trukownerdata: any;
  truckownerloading: boolean = false;
  driverdata: any;
  driverloading: boolean = false;
  admindata: any;
  adminloading: boolean = false;
  settingToTruckOwner: any;
  employeedata: any;
  settingToAdmin: any;
  search_btn: boolean = true;
  clear_btn: boolean = false;
  paginationTO: boolean = false;
  paginationDriver: boolean = false;
  paginationCustomer: boolean = true;
  paginationAdmin: boolean = false;
  employeePagination: boolean = false;
  TruckOwner: boolean = false;
  truckOwnerData: boolean = true;
  Customer: boolean = false;
  CustomerData: boolean = true;
  Drivers: boolean = false;
  DriversData: boolean = true;
  Admin: boolean = false;
  AdminData: boolean = true;
  EmployeesData: boolean = true;
  s9Employee: boolean = false;
  selectedDriverType: any = -1;
  page: any;
  typedValue: any = "";
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;

  constructor(
    private matDialog: MatDialog,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    let triptype = "users";
    localStorage.setItem("tripType", triptype);

    this.settingToTruckOwner = localStorage.getItem("truckOwner");
    this.settingToAdmin = localStorage.getItem("admin");

    if (this.settingToTruckOwner === "truckOwner") {
      localStorage.removeItem("truckOwner");
      this.UserType("truck-owners");
    } else if (this.settingToAdmin === "admin") {
      localStorage.removeItem("admin");
      this.UserType("admin");
    } else {
      this.UserType("Customers");
    }
  }

  UserType(userType: any) {
    this.selectedUserType = userType;
    this.closeSearch();
    this.isInputValid = false;

    // Immediately toggle the tab views so UI updates instantly
    this.userCustomer = userType === "Customers";
    this.userTruckOwner = userType === "truck-owners";
    this.userDriver = userType === "driver";
    this.userAdmin = userType === "admin";
    this.userEmployees = userType === "employees";

    if (this.selectedUserType == "Customers") {
      this.customerloading = true;
      this.customerMobile = -1;
      this.startPage = 1;
      this.fetch_page = 1;
      this.Customer = false;
      this.CustomerData = true;
      this.paginationCustomer = true;
      this.customerGet(this.customerMobile);
    }
    if (this.selectedUserType == "truck-owners") {
      this.truckownerloading = true;
      this.truckownerMobile = -1;
      this.truckStartPage = 1;
      this.truck_fetch_page = 1;
      this.TruckOwner = false;
      this.truckOwnerData = true;
      this.paginationTO = true;
      if (this.truckOwnerUserList) {
        this.truckOwnerUserList.paginator = this.paginatorTruckOwner;
      }
      this.truckOwnerGet(this.truckownerMobile);
    }
    if (this.selectedUserType == "driver") {
      this.driverloading = true;
      this.driverMobile = -1;
      this.driverStartPage = 1;
      this.dr_fetch_page = 1;
      this.Drivers = false;
      this.DriversData = true;
      this.paginationDriver = true;
      if (this.driverUserList) {
        this.driverUserList.paginator = this.paginatorDrivers;
      }
      this.driverGet(this.driverMobile);
    }
    if (this.selectedUserType == "admin") {
      this.adminloading = true;
      this.searchAdminName = -1;
      this.adminStartPage = 1;
      this.admin_fetch_page = 1;
      this.Admin = false;
      this.AdminData = true;
      this.paginationAdmin = true;
      if (this.adminUserList) {
        this.adminUserList.paginator = this.paginatorTruckOwner;
      }
      this.adminGet(this.searchAdminName);
    }
    if (this.selectedUserType == "employees") {
      this.searchEmployeeName = -1;
      this.employeeStartPage = 1;
      this.employee_fetch_page = 1;
      this.EmployeesData = true;
      this.s9Employee = false;
      this.employeePagination = true;
      if (this.employeeUserList) {
        this.employeeUserList.paginator = this.paginatorTruckOwner;
      }
      this.employeeGet(this.searchEmployeeName);
    }
  }

  customerGet(type: any) {
    this.customerMobile = type;
    this.customerloading = true;
    this.services
      .getUsersCustomers(
        this.token,
        this.perPage,
        this.startPage,
        this.customerMobile
      )
      .subscribe(
        (response: any) => {
          this.customerdata = response.body.data;
          this.document_array.push(response.body.meta);
          if (this.selectedUserType === "Customers") {
            this.last_page = response.body.meta.lastPage;
          }
          this.customerUserList = new MatTableDataSource(this.customerdata);
          this.customerUserList.paginator = this.paginatorCustomer;
          this.customerUserList.sort = this.sort;
          this.customerloading = false;

          if (
            this.customerUserList.data.length === 0 ||
            this.customerdata.length === 0
          ) {
            this.paginationCustomer = false;
            this.Customer = true;
            this.CustomerData = false;
          } else {
            this.paginationCustomer = true;
            this.Customer = false;
            this.CustomerData = true;
          }
        },
        (error) => {
          this.customerloading = false;
          this.handleApiError(error);
        }
      );
  }

  handleApiError(error: any) {
    if (
      error.error.message === "jwt malformed" ||
      error.error.message === "jwt expired" ||
      error.error.message === "invalid signature"
    ) {
      this.router.navigateByUrl("admin/login");
      window.localStorage.clear();
    } else {
      this.snackBar.open(error.error.message, "Fail", { duration: 5000 });
    }
  }
  truckOwnerGet(type: any) {
    this.truckownerMobile = type;
    this.services
      .getUsersTruckOwner(
        this.token,
        this.perPage,
        this.truckStartPage,
        this.truckownerMobile
      )
      .subscribe(
        (response: any) => {
          this.truckownerloading = false;
          this.trukownerdata = response.body.data;
          this.document_array.push(response.body.meta);
          if (this.selectedUserType === "truck-owners") {
            this.last_page = response.body.meta.lastPage;
          }
          this.truckOwnerUserList = new MatTableDataSource(this.trukownerdata);
          this.truckOwnerUserList.paginator = this.paginatorTruckOwner;
          this.truckOwnerUserList.sort = this.truckOwnersort;
          if (this.truckOwnerUserList.data.length === 0) {
            this.paginationTO = false;
            this.TruckOwner = true;
            this.truckOwnerData = false;
          } else {
            this.paginationTO = true;
            this.TruckOwner = false;
            this.truckOwnerData = true;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }


  // old: using admin/driver api
  // driverGet(type: any) {
  //   this.driverMobile = type;
  //   console.log("this.driverMobile",)
  //   this.services
  //     .getUsersDriver(
  //       this.token,
  //       this.perPage,
  //       this.driverStartPage,
  //       this.driverMobile
  //     )
  //     .subscribe(
  //       (response: any) => {
  //         this.driverloading = false;
  //         this.driverdata = [];
  //         this.driverdata = response.body.data.data;
  //         this.document_array.push(response.body.data.meta);
  //         this.last_page = response.body.data?.meta.lastPage;
  //         this.driverUserList = new MatTableDataSource(this.driverdata);
  //         this.driverUserList.paginator = this.paginatorDrivers;
  //         this.driverUserList.sort = this.driversort;
  //         if (this.driverUserList.data.length === 0) {
  //           this.paginationDriver = false;
  //           this.Drivers = true;
  //           this.DriversData = false;
  //         }
  //       },
  //       (error) => {
  //         if (error.error.message === "No records found") {
  //           this.Drivers = true;
  //           this.DriversData = false;
  //         }
  //         if (error.error.message === "jwt malformed") {
  //           this.router.navigateByUrl("admin/login");
  //           window.localStorage.clear();
  //         }
  //         if (error.error.message === "jwt expired") {
  //           this.router.navigateByUrl("admin/login");
  //           window.localStorage.clear();
  //         }
  //         if (error.error.message === "invalid signature") {
  //           this.router.navigateByUrl("admin/login");
  //           window.localStorage.clear();
  //         }
  //         this.snackBar.open(error.error.message, "Fail", {
  //           duration: 5000,
  //         });
  //       }
  //     );
  // }

  // New : using drivers/admin/list same as Admin-> drivers
  driverGet(type: any) {
    const driverType = -1;
    const order: 'asc' | 'desc' = 'asc';
    this.driverMobile = type;
    this.driverloading = true;
    this.services
      .driversGet(
        this.token,
        this.driverStartPage,
        driverType,
        this.driverMobile,
        order
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.driverloading = false;
            this.driverdata = [];
            this.driverdata = response.body.data.data;
            this.document_array.push(response.body.data.meta);
            if (this.selectedUserType == "driver") this.last_page = response.body.data?.meta.lastPage;
            // this.last_page = response.body.data?.meta.lastPage;
            this.driverUserList = new MatTableDataSource(this.driverdata);
            this.driverUserList.paginator = this.paginatorDrivers;
            this.driverUserList.sort = this.driversort;
            if (this.driverUserList.data.length === 0) {
              this.paginationDriver = false;
              this.Drivers = true;
              this.DriversData = false;
            } else {
              this.paginationDriver = true;
              this.Drivers = false;
              this.DriversData = true;
            }
          } else {
            this.driverloading = false;
          }
        },
        (error) => {
          this.driverloading = false;
          if (error.error.message === "No records found") {
            this.Drivers = true;
            this.DriversData = false;
          }
          if (
            error.error.message === "jwt malformed" ||
            error.error.message === "jwt expired" ||
            error.error.message === "invalid signature"
          ) {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  adminGet(type: any) {
    this.searchAdminName = type;
    this.adminloading = true;
    this.services
      .getUsersAdmin(
        this.token,
        this.searchAdminName,
        this.perPage,
        this.adminStartPage
      )
      .subscribe(
        (response: any) => {
          this.adminloading = false;
          this.admindata = response.body.data;
          this.document_array.push(response.body.meta);
          if (this.selectedUserType === "admin") {
            this.last_page = response.body.meta.lastPage;
          }
          this.adminUserList = new MatTableDataSource(this.admindata);
          this.adminUserList.paginator = this.paginatorTruckOwner;
          this.adminUserList.sort = this.adminrsort;
          if (this.adminUserList.data.length === 0) {
            this.paginationAdmin = false;
            this.Admin = true;
            this.AdminData = false;
            this.snackBar.open("No records found", "Fail", {
              duration: 5000,
            });
          } else {
            this.paginationAdmin = true;
            this.Admin = false;
            this.AdminData = true;
          }
        },
        (error) => {
          this.adminloading = false;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  employeeGet(type: any) {
    this.searchEmployeeName = type;
    this.services
      .getUsersEmployees(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.employeeStartPage
      )
      .subscribe(
        (response: any) => {
          this.employeedata = response.body.data;
          this.document_array.push(response.body.meta);
          if (this.selectedUserType === "employees") {
            this.last_page = response.body.meta.lastPage;
          }
          this.employeeUserList = new MatTableDataSource(this.employeedata);
          this.employeeUserList.paginator = this.paginatorTruckOwner;
          this.employeeUserList.sort = this.adminrsort;
          if (this.employeedata.length === 0) {
            this.employeePagination = false;
            this.EmployeesData = false;
            this.s9Employee = true;
          } else {
            this.employeePagination = true;
            this.EmployeesData = true;
            this.s9Employee = false;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  ngAfterViewInit() { }

  viewCustomers(item: any) {
    this.matDialogref = this.matDialog.open(AdminUserscustomerViewComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
      autoFocus: false,
    });
    this.matDialogref.afterClosed().subscribe((x) => {
      document.body.classList.add("no-scroll");
      this.customerGet(this.customerMobile);
    });
  }
  viewTruckOwner(item: any) {
    this.MatDialogref = this.matDialog.open(AdminUsersTruckownerViewComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
      autoFocus: false,
    });
    this.MatDialogref.afterClosed().subscribe((x) => {
      document.body.classList.add("no-scroll");
      this.truckOwnerGet(this.truckownerMobile);
    });
  }
  viewDrivers(item: any) {
    if (this.selectedUserType == "driver") {
      this.Matdialogref = this.matDialog.open(AdminEditDriversComponent, {
        width: "80vw",
        height: "80vh",
        data: item,
        autoFocus: false,
      });
      this.Matdialogref.afterClosed().subscribe((x) => {
        document.body.classList.add("no-scroll");
        this.driverGet(this.driverMobile);
      });
    }
  }
  viewAdmin(item: any) {
    if (this.selectedUserType == "admin") {
      this.Matdialogre = this.matDialog.open(AdminUsersAdminViewComponent, {
        width: "80vw",
        height: "80vh",
        data: item,
        autoFocus: false,
      });
      this.Matdialogre.afterClosed().subscribe((res: any) => {
        document.body.classList.add("no-scroll");
        this.adminGet(this.searchAdminName);
      });
    }
  }
  CreateEmployeeLogin(item: any) {
    if (this.selectedUserType == "employees") {
      this.Matdialogrefe = this.matDialog.open(
        AdminUsersCreateEmployeeLoginComponent,
        {
          width: "45vw",
          data: item,
          autoFocus: false,
        }
      );
    }
  }
  AddLogin(item: any) {
    if (this.selectedUserType == "admin") {
      this.Matdialogrefee = this.matDialog.open(AdminUsersAdminAddComponent, {
        width: "80vw",
        height: "80vh",
        data: item,
        autoFocus: false,
      });
      this.Matdialogrefee.afterClosed().subscribe((res: any) => {
        this.adminGet(this.searchAdminName);
      });
    }
  }
  resetPassword(item: any) {
    if (this.selectedUserType == "admin") {
      this.matdialogrefe = this.matDialog.open(
        AdminUserAdminResetPasswordComponent,
        {
          width: "40vw",
          data: item,
          autoFocus: false,
        }
      );
    }
  }
  viewEmployee(item: any) {
    if (this.selectedUserType == "employees") {
      this.Matdialogr = this.matDialog.open(AdminUsersEmployeesViewComponent, {
        width: "80vw",
        height: "80vh",
        data: item,
        autoFocus: false,
      });
    }
  }
  openpopup(item: any) {
    this.matdialogref = this.matDialog.open(AdminAddGeneralComponent, {
      data: item,
      autoFocus: false,
    });
    this.matdialogref.afterClosed().subscribe((res: any) => {
      setTimeout(() => {
        this.customerMobile = -1;
        this.customerGet(this.customerMobile);
        this.searchButton = true;
        this.toggleSearch = false;
        this.clear_btn = false;
        this.search_btn = true;
        this.customerloading = true;
      }, 1000);
    });
  }

  pagination(pageStatus: string): void {
    if (pageStatus === "-1" && this.fetch_page > 1) {
      this.fetch_page -= 1;
    } else if (pageStatus === "1" && this.fetch_page < this.last_page) {
      this.fetch_page += 1;
    } else if (pageStatus === "first") {
      this.fetch_page = 1;
    } else if (pageStatus === "last") {
      this.fetch_page = this.last_page;
    }
    this.currentPage = this.fetch_page;
    this.startPage = this.currentPage;
    this.customerGet(this.customerMobile);
  }

  paginationDR(page_status: string) {
    if (page_status === "-1" && this.dr_fetch_page > 1) {
      this.dr_fetch_page--;
    } else if (page_status === "1" && this.dr_fetch_page < this.last_page) {
      this.dr_fetch_page++;
    } else if (page_status === "first") {
      this.dr_fetch_page = 1;
    } else if (page_status === "last") {
      this.dr_fetch_page = this.last_page;
    }
    this.currentPage = this.dr_fetch_page;
    this.driverStartPage = this.dr_fetch_page;
    this.driverGet(this.driverMobile);
  }

  truckOwnerpagination(page_status: string) {
    switch (page_status) {
      case "-1":
        if (this.truck_fetch_page > 1) {
          this.truck_fetch_page -= 1;
        }
        break;
      case "1":
        if (this.truck_fetch_page < this.last_page) {
          this.truck_fetch_page += 1;
        }
        break;
      case "first":
        this.truck_fetch_page = 1;
        break;
      case "last":
        this.truck_fetch_page = this.last_page;
        break;
    }
    this.truckStartPage = this.truck_fetch_page;
    this.truckOwnerGet(this.truckownerMobile);
  }

  adminpagination(page_status: any) {
    if (page_status == "-1") {
      this.admin_fetch_page = parseInt(this.admin_fetch_page) - 1;
      this.currentPage = this.admin_fetch_page;
      this.adminStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.admin_fetch_page) + 1;
      this.admin_fetch_page = this.currentPage;
      this.adminStartPage = this.admin_fetch_page;
    }
    if (page_status == "first") {
      this.admin_fetch_page = 1;
      this.adminStartPage = 1;
    }
    if (page_status == "last") {
      this.admin_fetch_page = this.last_page;
      this.adminStartPage = this.last_page;
    }
    this.searchAdminName = -1;
    this.adminGet(this.searchAdminName);
  }

  employeepagination(page_status: any) {
    if (page_status == "-1") {
      this.employee_fetch_page = parseInt(this.employee_fetch_page) - 1;
      this.currentPage = this.employee_fetch_page;
      this.employeeStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.employee_fetch_page) + 1;
      this.employee_fetch_page = this.currentPage;
      this.employeeStartPage = this.employee_fetch_page;
    }
    if (page_status == "first") {
      this.employee_fetch_page = 1;
      this.employeeStartPage = 1;
    }
    if (page_status == "last") {
      this.employee_fetch_page = this.last_page;
      this.employeeStartPage = this.last_page;
    }
    this.searchEmployeeName = -1;
    this.employeeGet(this.searchEmployeeName);
  }

  openSearch() {
    this.toggleSearch = true;
    this.searchButton = false;
    this.search_btn = true;
    this.clear_btn = false;
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }
  closeSearch() {
    this.searchButton = true;
    this.toggleSearch = false;
    this.search_btn = true;
    this.clear_btn = false;
  }
  openSearchEmployee() {
    this.toggleSearch = true;
    this.searchButton = false;
    this.employeeCreate = true;
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }
  search(value: string) {
    if (!value) {
      this.searchAdminName = "";
      this.adminGet(this.searchAdminName);
      this.searchButton = true;
      this.toggleSearch = false;
    } else {
      const words = value.toLowerCase().split(" ");
      const capitalizedValue = words
        .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      this.search_btn = false;
      this.clear_btn = true;
      this.adminGet(capitalizedValue);
    }
  }

  customersearch(value: string) {
    const isNumeric = /^\d*$/.test(value);

    if (isNumeric && value.length > 0 && value.length <= 10) {
      if (value.length > 10) {
        this.snackBar.open("Mobile Number should be 10 digits only", "Fail", {
          duration: 5000,
        });
        this.customerMobile = -1;
        this.customerGet(this.customerMobile);
        this.customerloading = false;
      } else {
        this.search_btn = false;
        this.clear_btn = true;
        this.customerMobile = -1;
        this.startPage = 1;
        this.customerGet(value);
      }
    } else {
      this.customerloading = false;
    }
  }

  searchTO(value: string) {
    const isNumeric = /^\d*$/.test(value);

    if (isNumeric && value.length > 0 && value.length <= 10) {
      if (value.length > 10) {
        this.snackBar.open("Mobile Number should be 10 digits only", "Fail", {
          duration: 5000,
        });
        this.truckownerMobile = -1;
        this.truckOwnerGet(this.truckownerMobile);
        this.truckownerloading = false;
      } else {
        this.search_btn = false;
        this.clear_btn = true;
        this.truckownerMobile = -1;
        this.truckStartPage = 1;
        this.paginationTO = false;
        this.truckOwnerGet(value);
      }
    } else {
      this.truckownerloading = false;
    }
  }

  searchDriver(value: string) {
    const isNumeric = /^\d*$/.test(value);

    if (isNumeric && value.length > 0 && value.length <= 10) {
      if (value.length > 10) {
        this.snackBar.open("Mobile Number should be 10 digits only", "Fail", {
          duration: 5000,
        });
        this.driverMobile = -1;
        this.driverGet(this.driverMobile);
        this.driverloading = false;
      } else {
        this.search_btn = false;
        this.clear_btn = true;
        this.driverMobile = -1;
        this.driverStartPage = 1;
        this.driverGet(value);
      }
    } else {
      this.driverloading = false;
    }
  }

  searchEmployee(value: string) {
    if (!value) {
      this.searchEmployeeName = "";
      this.employeeGet(this.searchEmployeeName);
      this.searchButton = true;
      this.toggleSearch = false;
      this.employeeCreate = true;
    } else {
      const words = value.toLowerCase().split(" ");
      const capitalizedValue = words
        .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      this.search_btn = false;
      this.clear_btn = true;
      this.employeeGet(capitalizedValue);
    }
  }
  resetUsersList(value: string) {
    this.fetch_page = 1;
    this.startPage = 1;
    this.customerMobile = -1;
    this.clear_btn = false;
    this.CustomerData = true;
    this.Customer = false;
    this.search_btn = true;
    this.toggleSearch = false;
    this.searchButton = true;
    this.isInputValid = false;
    this.customerGet(this.customerMobile);
  }
  resetTOList(value: string) {
    this.truck_fetch_page = 1;
    this.truckStartPage = 1;
    this.truckownerMobile = -1;
    this.paginationTO = true;
    this.clear_btn = false;
    this.truckOwnerData = true;
    this.TruckOwner = false;
    this.search_btn = true;
    this.toggleSearch = false;
    this.searchButton = true;
    this.isInputValid = false;
    this.truckOwnerGet(this.truckownerMobile);
  }

  resetDriverList(value: string) {
    this.dr_fetch_page = 1;
    this.driverStartPage = 1;
    this.driverMobile = -1;
    this.clear_btn = false;
    this.search_btn = true;
    this.DriversData = true;
    this.Drivers = false;
    this.toggleSearch = false;
    this.searchButton = true;
    this.isInputValid = false;
    this.driverGet(this.driverMobile);
  }
  resetadminList(value: string) {
    this.searchAdminName = -1;
    this.clear_btn = false;
    this.AdminData = true;
    this.Admin = false;
    this.search_btn = true;
    this.toggleSearch = false;
    this.searchButton = true;
    this.adminGet(this.searchAdminName);
  }
  resetEmployeeList(value: string) {
    this.searchEmployeeName = -1;
    this.clear_btn = false;
    this.AdminData = true;
    this.Admin = false;
    this.search_btn = true;
    this.toggleSearch = false;
    this.searchButton = true;
    this.employeeGet(this.searchEmployeeName);
  }

  onInputChangeCustomer(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.previousValue.length > previousLength && this.clear_btn) {
      this.customerAPI();
      this.search_btn = true;
      this.clear_btn = false;
    }
    this.isInputValid = value.length >= 4;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.customerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.customerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.customerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.customerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.customerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.customerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.customerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      default:
        if (value.length >= 4) {
          this.lengthState = 0;
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;
    }

    if (value.length === 0) {
      if (this.newItem) {
        this.newItem.nativeElement.value = "";
      }
      this.toggleSearch = false;
      this.clear_btn = false;
      this.search_btn = false;
      this.searchButton = true;
    }
  }

  private customerAPI() {
    this.customerMobile = -1;
    this.customerGet(this.customerMobile);
    this.fetch_page = 0;
  }

  onInputChangeTO(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.previousValue.length > previousLength && this.clear_btn) {
      this.truckOwnerAPI();
      this.search_btn = true;
      this.clear_btn = false;
    }
    this.isInputValid = value.length >= 4;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.truckOwnerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.truckOwnerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.truckOwnerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.truckOwnerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.truckOwnerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.truckOwnerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.truckOwnerAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      default:
        if (value.length >= 4) {
          this.lengthState = 0;
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;
    }

    if (value.length === 0) {
      if (this.newItem) {
        this.newItem.nativeElement.value = "";
      }
      this.toggleSearch = false;
      this.clear_btn = false;
      this.search_btn = false;
      this.searchButton = true;
    }
  }

  private truckOwnerAPI() {
    this.truckownerMobile = -1;
    this.truckOwnerGet(this.truckownerMobile);
    this.fetch_page = 0;
    this.TruckOwner = false;
    this.truckOwnerData = true;
  }

  onInputChangeDriver(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.previousValue.length > previousLength && this.clear_btn) {
      this.driverAPI();
      this.search_btn = true;
      this.clear_btn = false;
    }
    this.isInputValid = value.length >= 4;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.driverAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.driverAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.driverAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.driverAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.driverAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.driverAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.driverAPI();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      default:
        if (value.length >= 4) {
          this.lengthState = 0;
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;
    }

    if (value.length === 0) {
      if (this.newItem) {
        this.newItem.nativeElement.value = "";
      }
      this.toggleSearch = false;
      this.clear_btn = false;
      this.search_btn = false;
      this.searchButton = true;
    }
  }

  private driverAPI() {
    this.driverMobile = -1;
    this.driverGet(this.driverMobile);
    this.fetch_page = 0;
    this.Drivers = false;
    this.DriversData = true;
  }

  onInputChangeAdmin(value: any) {
    if (value.length === 0) {
      this.searchAdminName = -1;
      this.clear_btn = false;
      this.AdminData = true;
      this.Admin = false;
      this.search_btn = true;
      this.toggleSearch = false;
      this.searchButton = true;
      this.adminGet(this.searchAdminName);
    }

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }
    const words = value.toLowerCase().split(" ");
    const capitalizedValue = words
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    const previousLength = this.previousValue.length;
    this.previousValue = capitalizedValue;

    if (
      capitalizedValue.length < previousLength ||
      (capitalizedValue.length > previousLength && this.clear_btn)
    ) {
      this.searchAdminName = -1;
      this.AdminData = true;
      this.Admin = false;
      this.search_btn = true;
      this.clear_btn = false;
      this.adminGet(this.searchAdminName);
    }

    if (capitalizedValue.length >= 1) {
      this.isInputValid = true;
    }
  }

  onInputChangeEmployee(value: any) {
    if (value.length === 0) {
      this.searchEmployeeName = -1;
      this.clear_btn = false;
      this.search_btn = true;
      this.toggleSearch = false;
      this.searchButton = true;
      this.employeedata = [];
      this.employeeGet(this.searchEmployeeName);
    }
    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }
    const words = value.toLowerCase().split(" ");
    const capitalizedValue = words
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    const previousLength = this.previousValue.length;
    this.previousValue = capitalizedValue;

    if (
      capitalizedValue.length < previousLength ||
      (capitalizedValue.length > previousLength && this.clear_btn)
    ) {
      this.clear_btn = false;
      this.search_btn = true;
      this.s9Employee = false;
      this.EmployeesData = true;
      this.searchEmployeeName = -1;
      this.employeeGet(this.searchEmployeeName);
    }

    if (capitalizedValue.length >= 1) {
      this.isInputValid = true;
    }
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
